import React from 'react';
// import ReactGA from "react-ga";

export class Search extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectionClick = this.handleSelectionClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);

        this.state = {
            value: '',
            showCloseIcon: false
        };
    }

    componentDidMount() {
        function compare(a, b) {
            if (parseInt(a.population) > parseInt(b.population)) {
                return -1;
            }
            if (parseInt(a.population) < parseInt(b.population)) {
                return 1;
            }
            return 0;
        }

        let kreise_by_pop = [];
        for (const [key, value] of Object.entries(this.props.kreise)) {
            kreise_by_pop.push(value);
        }
        kreise_by_pop.sort(compare)
        this.setState({kreise_by_pop: kreise_by_pop})
    }

    handleSubmit(e, value) {
        const self = this;
        if (e) {
            e.preventDefault();
            value = self.state.value;
        }

        let startswith_res = [];
        let contains_res = [];

        // ReactGA.event({
        //     category: 'Suche',
        //     action: this.state.value
        // });

        self.state.kreise_by_pop.forEach(function(kreis) {
            if (kreis.city.toLowerCase().startsWith(value.toLowerCase())) {
                startswith_res.push(kreis);
            } else if (kreis.city.toLowerCase().includes(value.toLowerCase())) {
                contains_res.push(kreis)
            }
        })

        let i = 0;
        let results = [];
        startswith_res.forEach(function(kreis) {
            if (i < 4) {
                i++;
                results.push(kreis);
            }
        })
        contains_res.forEach(function(kreis) {
            if (i < 4) {
                i++;
                results.push(kreis);
            }
        })

        self.setState({
            results: results,
            showCloseIcon: true
        })
    }

    handleChange(e) {
        const self = this;
        self.setState({
            value: e.target.value
        });
        self.handleSubmit(null, e.target.value);
    }

    handleCloseClick() {
        this.setState({
            value: '',
            results: null,
            showCloseIcon: false
        })
        this.props.closeSearch();
    }

    handleSelectionClick(kreis) {
        // ReactGA.event({
        //     category: 'Suchergebnisse-Klick',
        //     action: kreis.city
        // });

        this.setState({
            value: kreis.city,
            results: null,
            showCloseIcon: true
        }, this.props.handleSearchResClick(kreis))
    }

    render() {
        return (
            <>
                <form onSubmit={this.handleSubmit}>
                    <div className="searchDiv rounded">
                        <input
                            id="wahlkarteSearch"
                            className={"border " + (this.state.results ? "rounded-top-left" : "rounded-left")}
                            type="text"
                            placeholder="Geben Sie Ihre Stadt/Kreis ein ..."
                            value={this.state.value}
                            onChange={this.handleChange.bind(this)}
                            autoComplete="off"
                        />
                        <div
                            className={"border search-icon " + (this.state.results ? "rounded-top-right" : "rounded-right")}
                            onClick={this.handleCloseClick.bind(this)}
                        >
                            {this.state.typingTimeout
                                ?
                                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                                :
                                this.state.showCloseIcon
                                    ?
                                    <b>×</b>
                                    :
                                    <img
                                        alt="X-Icon"
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABD0lEQVRIie2UPW7CQBCFP5IS0gEnoQdyAxAHSQoUUSD+Gm4DIiegoITkAOEMJIQWTDFvwY3xrqFAUZ402rX95r2xvTPwV1EGRsAHsFOsgCFQula8BWyBKCF+gOY14gcJTYAqkFfUgKme7YFGqHg5Vnn7Au9NnG+gGGIw4lx5GmbiDkIMPpVU9eDWxV2FGPwqqeDBfRJ3m0Z8iO2jgGJyvsS4wVprxSPPcb5CDN61vngYvGqdeXBPKGFNFGFHMQkdcTZk6Oom1kSRqqtjP70APGNv6Tq6Gyru0MCaKGlUbCTurvtZTIpYEy2x47vTfsD5s8RNM5mkwY0MF+N/k7sy6bmbjzc0WGAzak7gGL9vHAG+Ol6n6x8u5AAAAABJRU5ErkJggg=="
                                    />
                            }
                        </div>
                    </div>
                </form>
                {this.state.results
                &&
                <div className="border rounded-bottom searchResults">
                    {this.state.results.length
                        ?
                        this.state.results.map(res => (
                            <div className="selectable" onClick={() => this.handleSelectionClick(res)}>
                                <p>
                                    <b>{res.city}</b>
                                </p>
                            </div>
                        ))
                        :
                        <div>
                            <p>
                                <i>Keine Suchergebnisse gefunden</i>
                            </p>
                        </div>
                    }
                </div>
                }
            </>
        )
    }
}